module.exports = __webpack_public_path__ + "img/full1-min.78ac914e.png";